import { AxiosResponse } from 'axios';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import {
  ICreateHoaRequest,
  ICreateHoaResponse,
  IGetHoaResponse,
  IUpdateHoaRequest,
} from '../../types/order/hoa/IHoaDetailsTypes';

const convertHoaFormToCreateHoaRequest = (formValues: IUpdateHoaRequest): ICreateHoaRequest => {
  return {
    name: formValues.name,
    mgmtCoName: formValues.mgmtCoName,
    primaryContactName: formValues.primaryContactName,
    primaryContactEmail: formValues.primaryContactEmail,
    primaryContactPhone: formValues.primaryContactPhone,
  };
};

export const createHoaDetailsAsync = async (formValues: IUpdateHoaRequest): Promise<ICreateHoaResponse> => {
  const createRequest: ICreateHoaRequest = convertHoaFormToCreateHoaRequest(formValues);
  return APIFactory(baseUrlService.ApiLocation)
    .post(`/timber/api/internal/orders/${formValues.orderId}/hoas`, createRequest)
    .then((response: AxiosResponse<ICreateHoaResponse>) => response.data)
    .catch(axiosErrorHandler);
};

export const getHoaDetailsAsync = async (orderId: string): Promise<IGetHoaResponse> => {
  return APIFactory(baseUrlService.ApiLocation)
    .get<IGetHoaResponse>(`/timber/api/internal/orders/${orderId}/hoas`)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
};

export const updateHoaDetailsAsync = async (formValues: IUpdateHoaRequest): Promise<ICreateHoaResponse> => {
  const createRequest: ICreateHoaRequest = convertHoaFormToCreateHoaRequest(formValues);
  return APIFactory(baseUrlService.ApiLocation)
    .put(`/timber/api/internal/orders/${formValues.orderId}/hoas/${formValues.id}`, createRequest)
    .then((response: AxiosResponse<ICreateHoaResponse>) => response.data)
    .catch(axiosErrorHandler);
};

export const deleteHoaDetailsAsync = async (formValues: IUpdateHoaRequest) => {
  APIFactory(baseUrlService.ApiLocation)
    .delete(`/timber/api/internal/orders/${formValues.orderId}/hoas/${formValues.id}`)
    .catch(axiosErrorHandler);
};
